/* eslint-disable jsx-a11y/aria-role */

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Icon from '../Icon'

const styles = theme => ({
  'button-text': {
    fontSize: 14,
    lineHeight: '18px',
    textTransform: 'none',
    fontWeight: 400,
    color: `var(--gameday-paging-rowsColor, ${theme.paging.rowsColor})`,
    padding: '0',
    margin: '0 4px',
    backgroundColor: `var(--gameday-paging-bgColor, ${theme.paging.bgColor})`,
    borderRadius: '.25rem',
    cursor: 'pointer',
    minHeight: '30px',
    minWidth: '30px',
    '&:hover': {
      backgroundColor: `var(--gameday-paging-hoverBgColor, ${theme.paging.hoverBgColor})`,
    },
    '&.disabled': {
      background: 0,
      color: `var(--gameday-paging-disabledColor, ${theme.paging.disabledColor})`,
      cursor: 'default',
      '&:hover': {
        cursor: 'not-allowed',
      },
      '& svg.disabled': {
        color: `var(--gameday-paging-disabledColor, ${theme.paging.disabledColor})`,
      },
    },
  },
  numberPagination: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    height: 30,
    fontSize: theme.typography.fontSizeSmaller,
    fontWeight: theme.typography.fontWeightBold,
    '& li': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 30,
      color: `var(--gameday-paging-textColor, ${theme.paging.textColor})`,
      backgroundColor: `var(--gameday-paging-bgColor, ${theme.paging.bgColor})`,
      borderRadius: theme.borders.borderRadius,
      border: '1px solid transparent',
      margin: '0 4px',
      padding: '0 2px',
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&.active': {
        fontWeight: '700',
        color: theme.paging.activeColor,
        borderColor: theme.paging.activeBorderColor,
        backgroundColor: theme.paging.activeBgColor,
        '&:hover': {
          backgroundColor: theme.paging.activeBgColor,
          borderColor: theme.paging.activeBorderColor,
          cursor: 'default',
        },
      },
      '&:hover': {
        background: `var(--gameday-paging-hoverBgColor, ${theme.paging.hoverBgColor})`,
        borderColor: `var(--gameday-paging-hoverBgColor, ${theme.paging.hoverBgColor})`,
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    '& .button-text': {
      fontSize: 14,
      lineHeight: 18,
      textTransform: 'none',
      fontWeight: 400,
      color: '#999',
      padding: '4px 6px',
      margin: '0 2px',
      backgroundColor: 'transparent',
      borderRadius: '.25rem',
      cursor: 'pointer',
    },
  },
  smallPagination: {
    justifyContent: 'flex-end',
  },
  onlyItem: {
    justifyContent: 'center',
  },
  extrasmall: {
    '& .dots': {
      display: 'none',
    },
    '& .first-no': {
      display: 'none',
    },
    '& .last-no': {
      display: 'none',
    },
    '& .MuiButton-text': {
      padding: '6px 2px',
      minWidth: '16px',
    },
  },
})

const renderNumberPage = (numPage, activePage, setPage, visiblePage) => {
  const pages = []
  if (!numPage) {
    return pages
  }

  if (numPage <= visiblePage + 2) {
    for (let i = 1; i <= numPage; i += 1) {
      pages.push(
        // biome-ignore lint/a11y/noStaticElementInteractions: TODO
        <li key={i} role="presentation" onClick={() => setPage(i)} className={activePage === i ? 'active' : ''}>
          {i}
        </li>
      )
    }

    return pages
  }

  if (activePage <= visiblePage) {
    for (let i = 1; i <= visiblePage; i += 1) {
      pages.push(
        // biome-ignore lint/a11y/noStaticElementInteractions: TODO
        <li key={i} role="presentation" onClick={() => setPage(i)} className={activePage === i ? 'active' : ''}>
          {i}
        </li>
      )
    }
    pages.push(
      <li key="___" className="dots">
        ...
      </li>
    )
    pages.push(
      // biome-ignore lint/a11y/noStaticElementInteractions: TODO
      <li key={numPage} className="last-no" role="presentation" onClick={() => setPage(numPage)}>
        {numPage}
      </li>
    )

    return pages
  }

  if (activePage >= numPage - (visiblePage - 1)) {
    pages.push(
      // biome-ignore lint/a11y/noStaticElementInteractions: TODO
      <li className="first-no" key={1} role="presentation" onClick={() => setPage(1)}>
        1
      </li>
    )
    pages.push(<li className="dots">...</li>)
    for (let i = numPage - (visiblePage - 1); i <= numPage; i += 1) {
      pages.push(
        // biome-ignore lint/a11y/noStaticElementInteractions: TODO
        <li key={i} role="presentation" onClick={() => setPage(i)} className={activePage === i ? 'active' : ''}>
          {i}
        </li>
      )
    }

    return pages
  }

  pages.push(
    // biome-ignore lint/a11y/noStaticElementInteractions: TODO
    <li key={1} className="first-no" role="presentation" onClick={() => setPage(1)}>
      1
    </li>
  )
  pages.push(<li className="dots">...</li>)
  for (let i = activePage - Math.floor(visiblePage / 2); i <= activePage + Math.floor(visiblePage / 2); i += 1) {
    pages.push(
      // biome-ignore lint/a11y/noStaticElementInteractions: TODO
      <li key={i} role="presentation" onClick={() => setPage(i)} className={activePage === i ? 'active' : ''}>
        {i}
      </li>
    )
  }
  pages.push(<li className="dots">...</li>)
  pages.push(
    // biome-ignore lint/a11y/noStaticElementInteractions: TODO
    <li key={numPage} className="last-no" role="presentation" onClick={() => setPage(numPage)}>
      {numPage}
    </li>
  )

  return pages
}

const Pagination = ({
  numPage,
  activePage,
  setPage,
  visiblePage,
  classes,
  smallPagination,
  showExportData,
  hideSizePerPage,
  hideShowingRows,
}) => {
  const curPage = Number(activePage)
  const nPage = Number(numPage)
  const visPage = Number(visiblePage)
  const pages = renderNumberPage(nPage, curPage, setPage, visPage)
  const iconSize = 20

  return (
    <div
      className={cn(classes.pagination, {
        [classes.smallPagination]: smallPagination && !showExportData,
        [classes.extrasmall]: smallPagination && visPage <= 3,
        [classes.onlyItem]: hideSizePerPage && hideShowingRows,
      })}
    >
      <Button
        role="presentation"
        onClick={() => curPage !== 1 && setPage(1)}
        className={cn(classes['button-text'], curPage === 1 ? 'disabled' : '')}
        alt="First Page"
        aria-label="First Page"
      >
        <Icon iconName="pager_first" iconSize={iconSize} className={curPage === 1 ? 'disabled' : ''} />
      </Button>
      <Button
        role="presentation"
        onClick={() => curPage > 1 && setPage(curPage - 1)}
        className={cn(classes['button-text'], curPage <= 1 ? 'disabled' : '')}
        alt="Previous Page"
        aria-label="Previous Page"
      >
        <Icon iconName="pager_left" iconSize={iconSize} className={curPage <= 1 ? 'disabled' : ''} />
      </Button>
      {/** biome-ignore lint/a11y/useValidAriaRole: TODO */}
      <ul role="presentaion" className={classes.numberPagination}>
        {pages}
      </ul>
      <Button
        role="presentation"
        onClick={() => curPage < nPage && setPage(curPage + 1)}
        className={cn(classes['button-text'], curPage >= nPage ? 'disabled' : '')}
        alt="Next Page"
        aria-label="Next Page"
      >
        <Icon iconName="pager_right" iconSize={iconSize} className={curPage >= nPage ? 'disabled' : ''} />
      </Button>
      <Button
        role="presentation"
        onClick={() => curPage !== nPage && setPage(nPage)}
        className={cn(classes['button-text'], curPage === nPage ? 'disabled' : '')}
        alt="Last Page"
        aria-label="Last Page"
      >
        <Icon iconName="pager_last" iconSize={iconSize} className={curPage === nPage ? 'disabled' : ''} />
      </Button>
    </div>
  )
}

Pagination.defaultProps = {
  numPage: 1,
  activePage: 1,
  visiblePage: 5,
  setPage: () => {},
  smallPagination: false,
}

export default withStyles(styles)(Pagination)
